import React from 'react';
import PropTypes from 'prop-types';
import { ScrollLink } from 'react-scroll';

const CustomScrollLink = (props) => (
  <div {...props}>
    {props.children}
  </div>
);

CustomScrollLink.propTypes = {
  children: PropTypes.object
};

export default ScrollLink(CustomScrollLink);

